import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import 'firebase/functions';
import 'firebase/messaging';
import 'firebase/storage';

firebase.initializeApp({ 
  apiKey: "AIzaSyAeFpnCSrlQ9Mo_PUcQmvBjjPob_1wKpLk",
  authDomain: "tatext-thirdpool.firebaseapp.com",
  databaseURL: "https://tatext-thirdpool.firebaseio.com",
  projectId: "tatext-thirdpool",
  storageBucket: "tatext-thirdpool.appspot.com",
  messagingSenderId: "809430246449",
  appId: "1:809430246449:web:1b596f46e28de61a"
});

export const requestPermission = async () => {
  try {
    const messaging = firebase.messaging();
    await messaging.requestPermission()
    let token = await messaging.getToken();
    return token;
  } catch (err) {
    // eslint-disable-next-line
    console.error(err.message);
  }
}

export const auth = firebase.auth();

export const db = firebase.firestore();

export const fbstore = firebase.storage();

export const sendMessage = firebase.functions().httpsCallable('sendMessage');

export const createCreds = firebase.functions().httpsCallable('createCreds');

export const scheduleCampaign = firebase.functions().httpsCallable('scheduleCampaign');

export const scheduleCampaignTest = firebase.functions().httpsCallable('scheduleCampaignTest');

export const testRunCampaign = firebase.functions().httpsCallable('testRunCampaign');

export const getSubUserList = firebase.functions().httpsCallable('getSubUserList');

export const getPhoneData = firebase.functions().httpsCallable('getPhoneData');

export const getMediaDetails = firebase.functions().httpsCallable('getMediaDetails');

export const shareProspect = firebase.functions().httpsCallable('shareProspect');

export const getSameUserIDList = firebase.functions().httpsCallable('getSameUserIDList');

export const cancelCampaign = firebase.functions().httpsCallable('cancelCampaign');

export const getAppSettings = firebase.functions().httpsCallable('getAppSettings');

export const updateProspectNumber = firebase.functions().httpsCallable('updateProspectNumber');

export const sentManager = firebase.functions().httpsCallable('sentManager');

export const makeCall = firebase.functions().httpsCallable('makeCall');

export const storeEmail = firebase.functions().httpsCallable('storeEmail');
